export default __webpack_public_path__ + "static/media/Wine.0b5ae245.mp3";